// SUR-1868 — the canonical Connect property-search filter vocabulary (option keys
// + display labels). SINGLE SOURCE OF TRUTH shared by BOTH the public Custom
// Search filter panel (app/javascript/connect/islands/SearchFilterPanel.jsx) and
// the CRM saved-search editor (pages/people/tabs/SavedSearches), so the agent's
// editor can never offer a different set of filters than the customer site.
//
// Keys match Connect::SavedSearchParams (Ruby), which normalizes the query before
// it hits ez. Add a filter in ONE place (here + the Ruby whitelist) and both UIs
// pick it up.

// [queryKey, label] for boolean / tri-state pill filters.
export type FilterOption = [string, string];
// [value, label] for the numeric segmented / select filters ('' = "Any").
export type FilterCountOption = [number | '', string];

// Boolean home-type filters → emitted as `true`. Order = display order.
// `commercial` (Commercial Sale + Business Opportunity) is opt-in: ez excludes
// those listings from every search unless the flag is set (EZH-3308), so an
// unchecked picker means "any home", never "any listing".
export const HOME_TYPES: FilterOption[] = [
  ['single_family_detached', 'House'], ['condo', 'Condo'], ['townhome', 'Townhome'],
  ['multi_family', 'Multi-family'], ['manufactured_home', 'Manufactured'],
  ['mobile_home', 'Mobile'], ['duplex', 'Duplex'], ['land', 'Land / lot'],
  ['commercial', 'Commercial'],
];

// Listing-status booleans.
export const STATUSES: FilterOption[] = [
  ['active', 'Active'], ['coming_soon', 'Coming soon'],
  ['active_under_contract', 'Under contract'], ['pending', 'Pending'],
];

// Recency / situational booleans.
export const RECENCY: FilterOption[] = [
  ['just_listed', 'Just listed'], ['price_reduced', 'Price reduced'],
  ['price_change', 'Price change'], ['new_construction', 'New construction'],
  ['existing', 'Existing'], ['open_house', 'Open house'],
  ['foreclosure', 'Foreclosure'], ['short_sale', 'Short sale'],
];

// Tri-state in ez (-1 exclude / 0 ignore / 1 require); the UIs toggle require(1) ↔ off(0).
export const FEATURES: FilterOption[] = [
  ['private_pool', 'Private pool'], ['community_pool', 'Community pool'],
  ['waterfront', 'Waterfront'], ['water_view', 'Water view'], ['ocean_view', 'Ocean view'],
  ['oceanfront', 'Oceanfront'], ['lakefront', 'Lakefront'], ['dock', 'Dock / boat slip'],
  ['fireplace', 'Fireplace'], ['basement', 'Basement'], ['elevator', 'Elevator'],
  ['gated', 'Gated'], ['no_hoa', 'No HOA'], ['senior_community', '55+ community'],
  ['single_story', 'Single story'], ['two_story', 'Two story'], ['multi_story', 'Multi story'],
  ['off_street_parking', 'Off-street parking'],
];

// new_to_market window, in days (0 = any time).
export const NEW_TO_MARKET: FilterCountOption[] = [
  [0, 'Any time'], [7, 'Last 7 days'], [14, 'Last 14 days'], [30, 'Last 30 days'],
];

// Minimum-count options for garage spaces.
export const GARAGE_COUNTS: FilterCountOption[] = [
  ['', 'Any'], [1, '1+'], [2, '2+'], [3, '3+'],
];
